const PropTypes = require('prop-types');
const React = require('react');
const { MobileDetection } = require('@reverbdotcom/discovery-ui');

const COPIED_FADE_DELAY_MS = 1500;
const SELECTED_FADE_DELAY_MS = 5000;

class ReferAFriendSocialButtons extends React.Component {
  static propTypes = {
    // The current user's referral link
    referralLink: PropTypes.string.isRequired,
  };

  static defaultProps = {
    isMobileBrowser: MobileDetection.isMobileBrowser(),
  };

  state = { copied: false, selected: false };

  render() {
    return (
      <section>
        {this.referralLink()}
        <div className="mt-1">
          <div className="g-container">
            {this.facebookShareButton()}
            {this.twitterShareButton()}
            {this.copyButton()}
          </div>
          {this.copiedMessage()}
        </div>
      </section>
    );
  }

  referralLink = () => {
    if (this.props.isMobileBrowser) {
      return (
        <div className="referral-link panel bordered">{this.props.referralLink}</div>
      );
    } else {
      return (
        <input ref="code"
          type="text"
          readOnly="true"
          value={this.props.referralLink}
          onClick={this.trackSelectLinkEventAndCopyText}
          className="align-center wide mtb-0 mlr-0"
        />
      );
    }
  };

  trackSelectLinkEventAndCopyText = (event) => {
    this.copyText(event);
  };

  copyText = (event) => {
    event.preventDefault();

    const input = this.refs.code;
    input.focus();
    input.setSelectionRange(0, input.value.length);

    const wasCopied = document.execCommand('copy');
    this.setState({
      selected: true,
      copied: wasCopied,
    });
  };

  copiedMessage = () => {
    if (this.state.copied) {
      return (
        <p ref="copiedMessage" className="copied-to-clipboard-tooltip mt-half mb-0">
          {I18n.t('js.referAFriendSocialButtons.copied')}
        </p>
      );
    }

    if (this.state.selected) {
      return (
        <p ref="selectedMessage" className="copied-to-clipboard-tooltip mt-half mb-0">
          {I18n.t('js.referAFriendSocialButtons.selected')}
        </p>
      );
    }
  };

  facebookShareButton = () => {
    return (
      <div className="g-col-4 g-col-mobile-12 mobile-mb-1">
        <a
          href={this.props.facebookLink}
          target="_blank"
          className="referral-facebook-share"
          rel="noopener noreferrer"
        >
          <i className="fa fa-facebook" /> {I18n.t('js.referAFriendSocialButtons.share')}
        </a>
      </div>
    );
  };

  twitterShareButton = () => {
    return (
      <div className="g-col-4 g-col-mobile-12 mobile-mb-1">
        <a
          href={this.props.twitterLink}
          target="_blank"
          className="referral-twitter-share"
          rel="noopener noreferrer"
        >
          <i className="fa fa-twitter" /> {I18n.t('js.referAFriendSocialButtons.tweet')}
        </a>
      </div>
    );
  };

  copyButton = () => {
    if (!this.props.isMobileBrowser) {
      return (
        <div className="g-col-4 g-col-mobile-12 mobile-mb-1">
          <a href="#" onClick={this.copyText} className="referral-copy-share">
            <i className="fa fa-clipboard" /> {I18n.t('js.referAFriendSocialButtons.copy')}
          </a>
        </div>
      );
    }
  };

  componentDidUpdate() {
    if (this.refs.copiedMessage) {
      $(this.refs.copiedMessage).show().delay(COPIED_FADE_DELAY_MS).fadeOut();
    }

    if (this.refs.selectedMessage) {
      $(this.refs.selectedMessage).show().delay(SELECTED_FADE_DELAY_MS).fadeOut();
    }
  }
}

module.exports = ReferAFriendSocialButtons;



// WEBPACK FOOTER //
// ./javascripts/components/refer_a_friend_social_buttons.jsx